import { useContext, createContext } from 'react';
/**
 * This provides the data that will be used by Smart Links Flexible UI to populate it's
 * underlying elements.
 */
export var FlexibleUiContext = /*#__PURE__*/createContext(undefined);
export var useFlexibleUiContext = function useFlexibleUiContext() {
  return useContext(FlexibleUiContext);
};

/**
 * This provides the data that will be used by Smart Links Flexible UI to populate it's
 * underlying elements.
 */
export var FlexibleUiAnalyticsContext = /*#__PURE__*/createContext(undefined);
export var useFlexibleUiAnalyticsContext = function useFlexibleUiAnalyticsContext() {
  return useContext(FlexibleUiAnalyticsContext);
};

/**
 * This provides the ui options that will be used by Smart Links Flexible UI
 * to render its underlying elements.
 */
export var FlexibleUiOptionContext = /*#__PURE__*/createContext(undefined);
export var useFlexibleUiOptionContext = function useFlexibleUiOptionContext() {
  return useContext(FlexibleUiOptionContext);
};